var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isPC() ? 'poprun_layout pc' : 'poprun_layout'},[(!_vm.isPC())?_c('NavBar',{style:({ position: 'absolute' })}):_vm._e(),(_vm.isPC())?_c('PcHeader'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }